import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import type { PropsWithChildren } from 'react'
import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(16)};

  ${mediaQueryUp.tablet} {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(${rem(184)}, 1fr));
    grid-auto-rows: minmax(${rem(142)}, auto);
    gap: ${rem(16)};
  }
`

interface Props extends PropsWithChildren {}

function TileCardsGroup({ children }: Props) {
  return <Container>
    {children}
  </Container>
}

export default TileCardsGroup
